import EmailSettingsTab from './email-settings';

export default EmailSettingsTab;
